import ReqClient from './request.class'

// 获取媒体下的账号（多账号）
export async function findAccountByMediaId(data) {
  const Req = new ReqClient({
    url: '/api/ptom/monior/findByMediaId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改新游管控规则状态
export async function updateAdcountState(data) {
  const Req = new ReqClient({
    url: '/api/ptom/monior/updateStatus',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改新游管控规则账号
export async function updateAdcountCount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/monior/updateAccount',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取新游管控规则列表（分页）
export async function getAdcountData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/monior/page',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取新游管控规则
export async function getAdcount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/monior/findByRuleId',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改新游管控规则
export async function editAdcount(data) {
  const Req = new ReqClient({
    url: '/api/ptom/monior/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取ai素材游戏配置列表
export async function getAiStrategys(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ai-strategy/queryAll',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新ai素材游戏配置
export async function updateAiStrategy(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ai-strategy/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新增ai素材游戏配置
export async function addAiStrategy(data) {
  const Req = new ReqClient({
    url: '/api/ptom/ai-strategy/create',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
